module.exports = __webpack_public_path__ + "media/images/stars/1-62b3d5b526570cb746b3f8ac469221dd.png";